export function getAllVariantsOfSearchTerm(term: string): string[] {
  if (!term || term === "") {
    return [] as string[];
  }

  const variants = [term, term.toLowerCase(), term.toUpperCase()];

  // Add capitalized variant as well:
  variants.push(term.charAt(0).toUpperCase() + term.slice(1));

  // Add a variant with the first letter of every word capitalized:
  variants.push(
    term
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "),
  );

  // Make sure to remove any duplicates:
  return Array.from(new Set(variants));
}
